module.exports = __webpack_public_path__ + "img/facebook.0aa13e7f.svg";